// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39RVO","field":"styles_field__26QQ0","fieldCol":"styles_fieldCol__1pRe_","diffCol":"styles_diffCol__Xd3-3","diff":"styles_diff__1tQ7W"};